module.exports = __webpack_public_path__ + "static/media/detail3.15b7aca8.jpg";